import React from 'react';
import './welcomeMessage.css'; // Adjust the path as necessary
import GalaxySubscribeButton from '../galaxySubscribeButton/GalaxySubscribeButton';

const WelcomeMessage = ({
  subscriptionStatus,
  playerId,
  isPlayerInRole,
  onSubscribe,
  onCancelRequest,
  onUnsubscribe,
  className,
  galaxyName = '',
}) => {
  if (subscriptionStatus === 'Subscribe') {
    return (
      <div className="centerText">
        <span className="centeredSpan">
          <p>
            <b>Welcome, {playerId}!</b>
          </p>
          <p>
            {/* <b>Step 1:</b>{' '} */}
            <GalaxySubscribeButton
              subscriptionStatus={subscriptionStatus}
              isPlayerInRole={isPlayerInRole}
              onSubscribe={onSubscribe}
              onCancelRequest={onCancelRequest}
              onUnsubscribe={onUnsubscribe}
              className={className}
            />
            {'   '}
            {`to enter ${galaxyName} and unlock all features.`}{' '}
          </p>
          {/* <p>
            <b>Step 2:</b> Personalize your experience! Update your{' '}
            <b>profile photo</b> and <b>cover photo</b> (top right) to earn
            bonus JGK tokens.
          </p>
          <p>
            <b>Step 3:</b> <b>Verify</b> your account by clicking the
            verification link below.
          </p> */}
          {/* <p style={{ marginTop: '1em', color: '#8a2be2' }}>
            <b>Tip:</b> Subscribing is required to participate in chat and
            posts!
          </p> */}
        </span>
      </div>
    );
  } else if (subscriptionStatus === 'Requested') {
    return (
      <div className="centerText">
        <span className="centeredSpan">
          <p>
            <b>Thank you, {playerId}!</b>
          </p>
          <p>
            Your request to join this Galaxy has been sent.
            <br />
            <span style={{ color: '#8a2be2', fontWeight: 500 }}>
              The Galaxy Admin will review your request soon.
              <br />
              <span role="img" aria-label="rocket">
                🚀
              </span>{' '}
              Stay tuned—you’ll be notified as soon as you’re approved!
            </span>
          </p>
          <p style={{ marginTop: '1em', color: '#00c6ff', fontWeight: 500 }}>
            Get ready to explore, connect, and make your mark!
          </p>
        </span>
      </div>
    );
  } else {
    return null;
  }
};

export default WelcomeMessage;
